<div class="modal">
  <div class="content">
    <img src="../../../assets/global/img/no-internet.svg" />
    <p>{{noInternet}}</p>
    <p class="description">{{noInternetMessage}}</p>
    <ion-button expand="block" (click)="retry()">{{retryText}}</ion-button>
  </div>
</div>
